import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { ACHIEVEMENT_FEATURE_KEY } from './keys';
import { EffectsModule } from '@ngrx/effects';
import { achievementReducer } from './reducers/achievement.reducer';
import { AchievementEffects } from './effects/achievement.effects';

@NgModule({
    imports: [CommonModule, StoreModule.forFeature(ACHIEVEMENT_FEATURE_KEY, achievementReducer), EffectsModule.forFeature(AchievementEffects)],
})
export class AchievementStoreModule {}
